import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { Loader, Table } from 'semantic-ui-react';
import Requests from '../../../services/requests';
import '../map.scss';
import { Utils } from '../../../services/utils/utils';

class WeatherLayerPopupContent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: false,
            queryParams: props.queryParams,
            outputData: []
        }
    }

    componentDidMount() {
        const { t } = this.props;

        // If weather info - skip request, as it currently does not contain weather specific information,
        // it is expected to be on the state.queryParams
        if(this.state.queryParams.dataTypeId === 12) {
            // Construct the outputData from queryParams
            const contJson = [{
                label: t('label.windSpeed'),
                value: this.state.queryParams.windSpeed,
                dataType: 'WEATHER',
                time: this.state.queryParams.time
            }, {
                label: t('label.windDirection'),
                value: this.state.queryParams.windDirection,
                dataType: 'WEATHER',
                time: this.state.queryParams.time
            }];
            this.setState({ outputData: contJson, loading: false, error: false });
        }
    }

    shouldComponentUpdate(prevProps, prevState) {
        return prevState.loading !== this.state.loading ||
            prevState.outputData.length !== this.state.outputData.length;
    }

    getOutputView = () => {
        const { t } = this.props;

        if (this.state.loading) {
            return (
                <Loader active inline='centered'>{t("keyBuild.loadingData")}...</Loader>
            )
        }

        if (this.state.error) {
            return (
                t('messages.errorCheckLogs')
            )
        }

        if (this.state.outputData.length === 0) {
            return null;
        }

        const firstOutput = this.state.outputData[0];

        // All the output data will be for the same data type/material, get the first data type and material to use in title
        const dataTypeTitle = t('dataTypes.' + firstOutput.dataType);
        const dateTime = new Date(firstOutput.time).toLocaleString();
        let title = dataTypeTitle;

        return (
            <>
                <div style={{ "textAlign": "center" }}>
                    <div style={{ "fontWeight": "800", "fontSize": "16px" }}>{title}</div>
                    <div>{dateTime}</div>
                </div>
                <div style={{ "marginTop": "10px" }}>
                    <div className="chart-div">
                        {this.getTable()}
                    </div>
                </div>
            </>
        );
    }

    getTable = () => {
        const { t } = this.props;
        const tableBodyRows = [];

        for (let ind in this.state.outputData) {
            const output = this.state.outputData[ind];
            tableBodyRows.push(<Table.Row key={"output-row-" + ind}>
                <Table.Cell>{output.label}</Table.Cell>
                <Table.Cell>{output.value}</Table.Cell>
            </Table.Row>)
        }

        return (
            <Table basic>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>{t('contourPopup.labels.label')}</Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableBodyRows}
                </Table.Body>
            </Table>
        )
    }

    render() {
        return this.getOutputView();   
    }

}

const mapStateToProps = (store) => {
    return {
        simulationState: store.simulationState,
        scenarioState: store.scenarioState,
        currentTime: store.mapState.currentTime,
        position: store.mapState.position,
    }
}
export default compose(withTranslation(), connect(mapStateToProps))(WeatherLayerPopupContent);